import React from 'react';
import clsx from 'clsx';
import useStyles from './styles';

const mapDirectionClasses = (classes: ReturnType<typeof useStyles>['classes']) => ({
  row: classes.alignRow,
  column: classes.alignColumn,
  columnReverse: classes.alignColumnReverse,
  rowReverse: classes.alignRowReverse,
});

const ActionAreaContainer = (props: ActionAreaContainerProps) => {
  const { children, direction = 'row', className, ...rest } = props;
  const { classes } = useStyles();
  const directionClasses = mapDirectionClasses(classes);
  const directionClass = directionClasses[direction];

  return (
    <div
      className={clsx(classes.actionAreaContainer, directionClass, className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export type ActionAreaContainerProps = {
  children: React.ReactNode;
  direction?: keyof ReturnType<typeof mapDirectionClasses>;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export default ActionAreaContainer;
